import { ENV } from '@/constants';
import { exploreSchemaItemList } from '../exploreSchema';

export const schemaObject_ImageEnlarger = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/image-enlarger',
			name: 'AI Image Enlarger',
			description:
				'Enlarge photos without losing quality using AI. Online image enlarger, no watermarks.',
			url: 'https://liftapp.ai/image-enlarger',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/image-enlarger#product' },
				{ '@id': 'https://liftapp.ai/image-enlarger#howto' },
				{ '@id': 'https://liftapp.ai/image-enlarger#benefits' },
				{ '@id': 'https://liftapp.ai/image-enlarger#faq' },
				{ '@id': 'https://liftapp.ai/image-enlarger#why-lift' },
				{ '@id': 'https://liftapp.ai/image-enlarger#explore-tools' },
				{ '@id': 'https://liftapp.ai/image-enlarger#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/image-enlarger#product',
			name: 'AI Image Enlarger',
			description:
				'Enlarge photos without losing quality using AI. Online image enlarger, no watermarks.',
			url: 'https://liftapp.ai/image-enlarger',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: 4.8,
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/image-enlarger#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload your photos',
					text: 'Choose a photo from your device or take one using Lift’s app',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Enlarge with AI',
					text: "Lift's AI enlarger increases image size while maintaining sharpness and detail",
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Customize adjustments',
					text: 'Fine-tune your image with easy-to-use editing tools',
				},
				{
					'@type': 'HowToStep',
					position: 4,
					name: 'Download and use',
					text: 'Download your image or publish it straight to your social feeds',
				},
			],
		},
		// benefit
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-enlarger#benefits',
			name: 'Who can benefit from AI Image Enlarger?',
			description:
				'Lift AI Image Enlarger helps e-commerce sellers, content creators, marketers, and more improve image quality instantly with AI retouching.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'AI Image Enlarger is perfect for anyone needing to scale photos without sacrificing quality',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Content creators and influencers for professional-looking posts',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Businesses and e-commerce sellers improving product visuals',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Event planners preserving memories in crisp detail',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Students or professionals can clarify scanned documents, screenshots, or images',
				},
				{
					'@type': 'ListItem',
					position: 6,
					name: 'Photographers can restore older or low-quality images effortlessly',
				},
				{
					'@type': 'ListItem',
					position: 7,
					name: 'AI Photo Enlarger bridges the gap between quick fixes and professional-quality results, making it indispensable for both personal and commercial use',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/Landing_2.96971f1d.webp',
				name: 'Benefit from Image Enlarger',
				description:
					'Faded apartment facade brought back to vivid, clean definition',
			},
		},

		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/image-enlarger#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What is Lift AI Image Enlarger?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift AI Image Enlarger is a premium online tool that improves photo clarity, colour and resolution up to 4K in a single click.',
					},
				},
				{
					'@type': 'Question',
					name: 'How does Lift AI Image Enlarger work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'AI Image Enlarger uses advanced super-resolution technology to rebuild pixel details and sharpen edges while preserving natural textures. Everything happens in the cloud — just upload, choose your scale (2× or 4×), and get stunning results in seconds.',
					},
				},
				{
					'@type': 'Question',
					name: 'Will enlarging make my photo blurry?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "No. Traditional enlargement causes pixelation and blur, but Lift's AI reconstructs detail as it scales. Your enlarged image stays sharp with natural textures — perfect for professional use, printing, or high-resolution displays.",
					},
				},
				{
					'@type': 'Question',
					name: 'Can I download the results without a watermark?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. All images generated or edited in Lift can be exported without watermark when you're on the Pro plan. Download them in high-res PNG or JPG — ready for social media, print, ads, or e-commerce.",
					},
				},
			],
		},

		// why lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-enlarger#why-lift',
			name: 'Why Lift’s AI Image Enlarger stands out',
			description:
				"Lift's AI Image Enlarger provides professional results, AI accuracy, cross-platform support, and is budget-friendly.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Professional results',
					description:
						'Achieve studio-quality images without the need for complex tools',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI accuracy',
					description:
						'Smart algorithms deliver enhancements tailored to your specific image',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Cross-platform support',
					description: 'Available on iOS, Android, and Web for seamless access',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'Budget-friendly',
					description:
						'Save on costly editing services with Lift’s affordable solution',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/Landing_3.c809c427.webp',
				name: 'Edited with Lift',
				description:
					'Soft and faded photo of a woman cleaned up into a crisp modern portrait',
			},
		},
		// explore
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-extender#explore-tools',
			name: 'Explore the AI tools',
			description:
				'A curated list of AI-powered tools for image generation, enhancement, background removal, and more – all available on Lift.',
			itemListOrder: 'Unordered',
			...exploreSchemaItemList,
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/image-enlarger#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'AI Image Enlarger',
					item: 'https://liftapp.ai/image-enlarger',
				},
			],
		},
	],
};
